export default import.meta.ROLLDOWN_FILE_URL_O6Drb1j2b438NFIx$mgA0w